import { Component, Input } from '@angular/core';
import { produit } from '../stores/interfaces/produits.interface';
import { RESPONSE_PRODUIT_INIT_STATE } from '../stores/reducers/produits.reducer';
import { getLink } from '../stores/utils';

@Component({
  selector: 'cardProduit',
  templateUrl: './cardProduit.component.html',
  styleUrls: ['./cardProduit.component.scss'],
})
export class CardProduitComponent {
  @Input() produit: produit = RESPONSE_PRODUIT_INIT_STATE;
  @Input() categorie: string = '';
  @Input() destination: string = '';
  @Input() tag: string = '';
  @Input() search: string = '';
  getLink = getLink;

  favoris() {
    const nb = this.produit.nbFavoris;
    this.produit = { ...this.produit, nbFavoris: nb + 1 };
  }
}